import * as ACTIONS from '../constants';

export function updateUser(payload)
{
    return {
        type: ACTIONS.UPDATE_USER_PROFILE,
        payload
    }
}

export function updateEditCryodexProfile(payload)
{
    return {
        type: ACTIONS.CRYODEX_EDIT_UPDATE,
        payload
    }
}

export function saveCryodexProfile(payload)
{
    return {
        type: ACTIONS.CRYODEX_UPDATE_USER,
        payload
    };
}

export function savingComplete()
{
    return {
        type: ACTIONS.SAVING_COMPLETE
    }
}

export function getSelectedCryodex(payload)
{
	return{
		type: ACTIONS.CRYODEC_GET_ISOLATED_CRYODEX,
        payload
	}	
}